import { render } from "./course-grid.vue?vue&type=template&id=8aa60ce6"
import script from "./course-grid.vue?vue&type=script&lang=js"
export * from "./course-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__